var map = {
	"./ID.webp": 786,
	"./INDO.webp": 787,
	"./MY.webp": 788,
	"./TH.webp": 789,
	"./VN.webp": 790,
	"./malaysia.webp": 791
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 394;
module.exports = webpackAsyncContext;